module.exports = __webpack_public_path__ + "static/media/for_agencies.d482b691.jpg";